const saveChangesRemote = ({
  pageState: { editorBlocks },
  data: { updatedAt }
}) => {
  return {
    editorBlocks: Object.keys(editorBlocks).reduce((blocks, blockId) => {
      blocks[blockId] = {
        ...editorBlocks[blockId],
        isEdited: false,
        isNew: false
      };

      return blocks;
    }, {}),
    editorChapterTitleIsEdited: false,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: false,
    editorIsSaving: false
  };
};

export default saveChangesRemote;
